module.exports = __webpack_public_path__ + "fonts/OpenSans-MediumItalic.a4345446.woff2";